import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getUserBadge } from '@/store/badge/actions';

import { selectBadge } from '@/store/badge/selectors';

import { Modal } from 'antd';

import BadgeElement from '@shared/components/BadgeElement';

import Utils from '@/Utils';
import PropTypes from 'prop-types';

import style from './style.module.scss';

const BadgeModal = ({ open, onCancel, withOutAction = false, data, showRewarded = false }) => {
  const { t } = useTranslation('badgeModal');
  const { badges } = useSelector(selectBadge);

  const dispatch = useDispatch();

  const isOnline = () => Utils.isOnline();

  useEffect(() => {
    if (!withOutAction && isOnline()) dispatch(getUserBadge());
  }, []);

  const renderBadges = useMemo(() => {
    if (data?.length) {
      return data?.map((elem, index) => (
        <BadgeElement size='xlarge' data={elem} key={index} disabled={showRewarded && !elem?.isRewarded} />
      ));
    } else if (badges?.length) {
      return badges?.map((elem, index) => <BadgeElement size='xlarge' data={elem} key={index} />);
    } else {
      return <div className={style['badge-modal__no-data']}>{t('noBadge')}</div>;
    }
  }, [data, badges]);

  return (
    <Modal footer={null} width={800} title={t('title')} open={open} onCancel={onCancel}>
      <div className={style['badge-modal']} data-qa='badgeModal'>
        {renderBadges}
      </div>
    </Modal>
  );
};

BadgeModal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  withOutAction: PropTypes.bool,
  data: PropTypes.array,
};

export default BadgeModal;
